/* This file is autogenerated, see readme.md for instructions */
import ChevronRightSvgIcon from '@bloomreach/banana-theme/icons/chevron-right.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const ChevronRightIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <ChevronRightSvgIcon />
    </Icon>
  );
});

ChevronRightIcon.displayName = 'ChevronRightIcon';

export default ChevronRightIcon;
